import React from 'react';
import { QuickLink } from '../types';
import LinkList from './LinkList';

interface LeaderboardProps {
    links: QuickLink[];
    onDelete: (id: string) => void;
    onOpenModal: () => void;
    isAdmin?: boolean;
    onAdd?: (title: string, url: string) => void;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ links, onDelete, onOpenModal, isAdmin, onAdd }) => (
    <LinkList
        links={links}
        onDelete={onDelete}
        onAdd={onAdd}
        onOpenModal={onOpenModal}
        isAdmin={isAdmin}
        addButtonText="Add Leaderboard"
        emptyText="No leaderboards yet. Click + to add."
        maxHeight="max-h-48"
    />
);

export default Leaderboard;
